module.exports = __webpack_public_path__ + "img/Budget.12522bb4.svg";